export const buildCardTestId = (title: string): string => {
  return `${title.toLowerCase().split(" ").join("-")}-card`.replace(
    /[.,/#!$%^&*;:"'`’{}=_~()]/g,
    ""
  );
};
